import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import NoInternetComp from "../../InternetConnetction/NoInternetComp";
import { getServices } from "../../../../apiServices/apiServices";
import toast from "react-hot-toast";
import config from "../../../../config.json";

function UserAnayticsView() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const access_token = sessionStorage.getItem("access-token");
  const url = config.url;

  useEffect(() => {
    fetchUserAnalyticsView();
  }, []);

  const fetchUserAnalyticsView = async () => {
    setLoading(true);

    try {
      const res = await getServices(`/api/ip/count`, access_token);
      setLoading(false);

      if (res.responseCode === 200) {
        setData(res.responseData);
      } else {
        setData([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  return (
    <>
      {navigator.onLine ? (
        <Container>
          <Container className="flex justify-between items-center mx-0 px-4 md:px-8 py-8">
            <p className="text-xl sm:text-2xl font-semibold">User Analytics</p>
          </Container>

          {!loading ? (
            <>
              <Container className="px-4 md:px-8 grid md:grid-cols-3 gap-4">
                <div className="grow-0 basis-auto">
                  <div className="bg-white text-[#1C252E] p-[calc(3*8px)] rounded-2xl box-shadow flex items-center">
                    <div className="grow">
                      <p className="text-sm font-publicsans font-medium">
                        Total Unique Visitors
                      </p>
                      <p className="mt-3 font-montserrat font-bold text-[32px] break-all">
                        {data.visitorCount ?? 0}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="grow-0 basis-auto">
                  <div className="bg-white text-[#1C252E] p-[calc(3*8px)] rounded-2xl box-shadow flex items-center">
                    <div className="grow">
                      <p className="text-sm font-publicsans font-medium">
                        Total Visited Categories
                      </p>
                      <p className="mt-3 font-montserrat font-bold text-[32px] break-all">
                        {data.topVisitedCategories?.length > 0
                          ? data.topVisitedCategories?.length
                          : 0}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="grow-0 basis-auto">
                  <div className="bg-white text-[#1C252E] p-[calc(3*8px)] rounded-2xl box-shadow flex items-center">
                    <div className="grow">
                      <p className="text-sm font-publicsans font-medium">
                        Total Visited Products
                      </p>
                      <p className="mt-3 font-montserrat font-bold text-[32px] break-all">
                        {data.topVisitedProducts?.length > 0
                          ? data.topVisitedProducts?.length
                          : 0}
                      </p>
                    </div>
                  </div>
                </div>
              </Container>

              <Container className="px-4 md:px-8 grid md:grid-cols-2 gap-4 my-4">
                <div className="grow-0 basis-auto">
                  <div className="bg-white text-[#1C252E] p-[calc(3*8px)] rounded-2xl box-shadow flex items-center">
                    <div className="grow">
                      <p className="text-sm font-publicsans font-medium mb-6">
                        Top Visited Categories
                      </p>

                      {data.topVisitedCategories?.length > 0 ? (
                        data.topVisitedCategories?.map((category, i) => (
                          <div key={i}>
                            <div className="flex items-center justify-between gap-4">
                              <div className="flex items-center gap-4">
                                <img
                                  src={
                                    category.image ? url + category.image : ""
                                  }
                                  alt="solmelu"
                                  className="h-16 w-16 rounded-full object-cover border"
                                />
                                <p className="font-medium">
                                  {category.name ?? "-"}
                                </p>
                              </div>
                              <p>{category.count ?? 0}</p>
                            </div>
                            <hr className="border-dashed my-3 border-gray-300" />
                          </div>
                        ))
                      ) : (
                        <Container className="text-center mx-8 mt-5 sm:mt-5">
                          <p className="font-medium">No data found!!!</p>
                        </Container>
                      )}
                    </div>
                  </div>
                </div>

                <div className="grow-0 basis-auto">
                  <div className="bg-white text-[#1C252E] p-[calc(3*8px)] rounded-2xl box-shadow flex items-center">
                    <div className="grow">
                      <p className="text-sm font-publicsans font-medium mb-6">
                        Top Visited Products
                      </p>

                      {data.topVisitedProducts?.length > 0 ? (
                        data.topVisitedProducts?.map((product, i) => (
                          <div key={i}>
                            <div className="flex items-center justify-between gap-4">
                              <div className="flex items-center gap-4">
                                <img
                                  src={product.image ? url + product.image : ""}
                                  alt="solmelu"
                                  className="h-16 w-16 rounded-full object-cover border"
                                />
                                <p className="font-medium">
                                  {product.name ?? "-"}
                                </p>
                              </div>
                              <p>{product.count ?? 0}</p>
                            </div>
                            <hr className="border-dashed my-3 border-gray-300" />
                          </div>
                        ))
                      ) : (
                        <Container className="text-center mx-8 mt-5 sm:mt-5">
                          <p className="font-medium">No data found!!!</p>
                        </Container>
                      )}
                    </div>
                  </div>
                </div>
              </Container>
            </>
          ) : (
            <Container className="min-h-[35vh] flex justify-center items-center">
              <p className="text-center font-semibold">Loading...</p>
            </Container>
          )}
        </Container>
      ) : (
        <Container className="min-h-[65vh] flex flex-col justify-center items-center">
          <NoInternetComp />
        </Container>
      )}
    </>
  );
}

export default UserAnayticsView;
